export type Nullable<T> = null | T;

export type Dictionary<T = string> = { [key: string]: T };

export enum SortDirection {
  DESC = "DESC",
  ASC = "ASC",
}
